export default function elementExists<T>(
  argument: T | undefined,
): argument is T {
  return argument !== undefined;
}
